export default "__VITE_ASSET__DPKtPUCC__"